<template>
  <div>
    <div
      id="date-select"
      uk-modal
    >
      <div class="uk-modal-dialog uk-modal-body">
        <functional-calendar
          v-model="calendarData"
          :configs="calendarConfigs"
        />
        <p>oder Zeitraum hier wählen</p>
        <div>
          <button
            v-for="(h, hIndex) in halfyearArr"
            :key="hIndex"
            class="uk-button uk-button-default uk-width-1-2 date-filter-btn"
            @click="setHalfyear(h.year, h.halfyear)"
          >
            {{ h.year }} / {{ h.halfyear }}. Halbjahr
          </button>
        </div>
        <hr>
        <div v-if="kurse.length > 0">
          <button
            v-for="(q, qindex) in quarterArr"
            :key="qindex"
            class="uk-button uk-button-default uk-width-1-2 date-filter-btn"
            @click="setQuarter(q.year, q.quarter)"
          >
            {{ q.year }} / Quartal {{ q.quarter }}
          </button>
        </div>
        <div v-if="calendarData.dateRange && calendarData.dateRange.start">
          <p>
            gewählter Zeitraum
          </p>
          <div class="sidebar_title uk-text-center ">
            <span v-text="calendarData.dateRange.start" />
            <span v-if="calendarData.dateRange.end">
              - {{ calendarData.dateRange.end }}</span>
          </div>
        </div>

        <div>
          <button
            class="uk-button uk-button-default uk-width-1-2 date-submit-btn"
            @click="hideDatePicker"
          >
            <span uk-icon="icon: close;" />
            Abbrechen
          </button>
          <button
            :disabled="!calendarData.dateRange.start"
            class="uk-button uk-button-default uk-width-1-2 date-submit-btn"
            @click="applyDateFilter"
          >
            <span uk-icon="icon: check;" />
            OK
          </button>
        </div>
        <!-- {{ calendarData }} -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  // eslint-disable-next-line no-trailing-spaces
  getQuarter,
  fromUnixTime,
  getYear,
  getMonth,
  getDate,
  endOfQuarter,
} from 'date-fns';
import { FunctionalCalendar } from 'vue-functional-calendar';

export default {
  components: { FunctionalCalendar },
  data() {
    return {
      today: new Date(),
      lastDate: null,
      calendarData: {
        dateRange: { start: '', end: '' },
      },
      calendarConfigs: {
        sundayStart: false,
        dateFormat: 'dd.mm.yyyy',
        dayNames: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        monthNames: [
          'Januar',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember',
        ],
        isModal: false,
        isDateRange: true,
      },
    };
  },
  computed: {
    ...mapGetters(['kurse']),
    quarterArr() {
      // erzeugt ein array mit den nächsten max. 4 quarteren inkl. aktuellem quarter,
      // sofern kurse in diesem zeitraum vorhanden
      const quarterArr = [];
      let fromYear = getYear(this.today);
      const toYear = getYear(this.lastDate);
      let fromQuater = getQuarter(this.today);
      while (fromYear <= toYear) {
        while (fromQuater <= 4) {
          quarterArr.push({ year: fromYear, quarter: fromQuater });
          fromQuater += 1;
        }
        fromQuater = 1;
        fromYear += 1;
      }
      // auf 4 einträge kürzen
      if (quarterArr.length > 4) {
        quarterArr.length = 4;
      }
      // quartere streichen deren datum nach letzten bekannten kurs liegen
      let resultArr = [];
      if (quarterArr.length > 0) {
        resultArr = _.filter(
          quarterArr,
          q => q.year < getYear(this.lastDate)
          || (q.year === getYear(this.lastDate)
            && q.quarter <= getQuarter(this.lastDate)),
        );
      }

      return resultArr;
    },
    halfyearArr() {
      const resultArr = [];
      const fromYear = getYear(this.today);
      const toYear = getYear(this.lastDate);
      if (fromYear !== toYear) {
        resultArr.push({ year: fromYear, halfyear: 2 });
        resultArr.push({ year: toYear, halfyear: 1 });
      } else {
        resultArr.push({ year: fromYear, halfyear: 1 });
        resultArr.push({ year: fromYear, halfyear: 2 });
      }
      return resultArr;
    },
  },
  methods: {
    ...mapMutations(['setFilter']),
    hideDatePicker() {
      UIkit.modal(document.getElementById('date-select')).hide();
    },
    applyDateFilter() {
      console.log('applyDateFilter');
      // console.log('calendarData', this.calendarData, this.kurse);
      this.setFilter({
        type: 'dateStart',
        val: this.calendarData.dateRange.start,
      });
      if (!this.calendarData.dateRange.end) {
        this.calendarData.dateRange.end = this.calendarData.dateRange.start;
      }
      this.setFilter({
        type: 'dateEnd',
        val: this.calendarData.dateRange.end,
      });
      this.hideDatePicker();
    },
    setQuarter(year, quarter) {
      console.log('setQuarter', year, quarter);
      let endDate = '';
      switch (quarter) {
        case 1:
          this.calendarData.dateRange.start = `1.1.${year}`;
          endDate = endOfQuarter(new Date(year, 1, 1, 11, 55, 0));
          this.calendarData.dateRange.end = `${getDate(
            endDate,
          )}.${getMonth(endDate) + 1}.${getYear(endDate)}`;
          break;
        case 2:
          this.calendarData.dateRange.start = `1.4.${year}`;
          endDate = endOfQuarter(new Date(year, 4, 1, 11, 55, 0));
          this.calendarData.dateRange.end = `${getDate(
            endDate,
          )}.${getMonth(endDate) + 1}.${getYear(endDate)}`;
          break;
        case 3:
          this.calendarData.dateRange.start = `1.7.${year}`;
          endDate = endOfQuarter(new Date(year, 7, 1, 11, 55, 0));
          this.calendarData.dateRange.end = `${getDate(
            endDate,
          )}.${getMonth(endDate) + 1}.${getYear(endDate)}`;
          break;
        case 4:
          this.calendarData.dateRange.start = `1.10.${year}`;
          endDate = endOfQuarter(new Date(year, 10, 1, 11, 55, 0));
          this.calendarData.dateRange.end = `${getDate(
            endDate,
          )}.${getMonth(endDate) + 1}.${getYear(endDate)}`;
          break;
        default:
          break;
      }
    },
    setHalfyear(year, halfyear) {
      if (halfyear === 1) {
        this.calendarData.dateRange.start = `1.1.${year}`;
        this.calendarData.dateRange.end = `30.6.${year}`;
      } else {
        this.calendarData.dateRange.start = `1.7.${year}`;
        this.calendarData.dateRange.end = `31.12.${year}`;
      }
    },
    clearCalendarDateSelection() {
      this.calendarData.dateRange.start = null;
      this.calendarData.dateRange.end = null;
    },
  },
  created() {
    this.lastDate = fromUnixTime(
      this.kurse[this.kurse.length - 1].kursstartdatum,
    );
  },
  updated() {
    console.log('calendarData.dateRange', this.calendarData.dateRange);
  },
};
</script>

<style lang="scss" scoped>
.uk-modal {
  background: initial;
  color: initial;
  a {
    color: initial;
  }
}
</style>
